//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import {
  FilterSection,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

export const DEFAULT_HAS_LABELS_FILTER_SECTION: FilterSection<boolean> = {
  options: [
    {
      isSelected: false,
      value: false,
      label: 'Not labeled',
      trackingId: MediaLibraryTrackingIds.LABELS_NOT_LABELED_CHECKBOX,
    },
    {
      isSelected: false,
      value: true,
      label: 'Labeled',
      trackingId: MediaLibraryTrackingIds.LABELS_LABELED_CHECKBOX,
    },
  ],
  paramKey: 'hasLabels',
};

export interface LabelsCheckboxProps {
  isDisabled?: boolean;
  section?: FilterSection<boolean>;
  subsection?: FilterSection<boolean>;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
}

export const LabelsCheckbox = ({
  isDisabled,
  onChange,
  section = DEFAULT_HAS_LABELS_FILTER_SECTION,
  subsection,
}: LabelsCheckboxProps) => (
  <CheckboxSetFilter
    isDisabled={isDisabled}
    isSingleSelect={true}
    onChange={onChange}
    section={section}
    subsection={subsection}
  />
);
